import { REDUCER } from './reducersConst';

/**
 * GUEST DATA REDUCER
 */
let defaultGuestState = {
  isFetching: false,
  resolvedClient: null,
  codeError: null,
  session: null,
  sessionExpiredModalIsOpen: false
};

/**
 * Guest Reducer
 * @param state
 * @param action
 * @returns {*}
 */
export let guest = (state = defaultGuestState, action) => {
  switch (action.type) {
    case REDUCER.GUEST.IS_FETCHING:
      return {
        ...state,
        isFetching: action.isFetching
      };
    case REDUCER.GUEST.SET_RESOLVED_CLIENT:
      return {
        ...state,
        resolvedClient: action.resolvedClient
      };
    case REDUCER.GUEST.SET_CODE_ERROR:
      return {
        ...state,
        codeError: action.codeError
      };
    case REDUCER.GUEST.SET_SESSION:
      return {
        ...state,
        session: action.session
      };
    case REDUCER.GUEST.SET_SESSION_EXPIRED_MODAL:
      return {
        ...state,
        sessionExpiredModalIsOpen: action.sessionExpiredModalIsOpen
      };
    case REDUCER.GUEST.CLEAR_SESSION:
      return {
        ...state,
        resolvedClient: null,
        codeError: null,
        session: null,
        sessionExpiredModalIsOpen: false
      };
    default:
      return state;
  }
};
